import { Component, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { DashboardService } from '../../dashboard.service';

// Utility function to set decimal points

interface Store {
  name: string;
  todaySales: number;
  todaySalesChange: number;
  todayLabour: number;
  todayLabourChange: number;
  weekSales: number;
  weekSalesChange: number;
  weekLabour: number;
  weekLabourChange: number;
}

@Component({
  selector: 'app-results-by-store',
  templateUrl: './results-by-store.component.html',
  styleUrls: ['./results-by-store.component.scss', '../../../dashboard.scss'],
  standalone: false
})
export class ResultsByStoreComponent {
  @Input() dashboardData: any;
  @Output() shopSelected = new EventEmitter<any>();
  stores: any = [];
  // stores: Store[] = [
  //   {
  //     name: 'AIRPORT',
  //     todaySales: 8513,
  //     todaySalesChange: 0.8,
  //     todayLabour: 15.7,
  //     todayLabourChange: 5.39,
  //     weekSales: 8513,
  //     weekSalesChange: 0.8,
  //     weekLabour: 15.7,
  //     weekLabourChange: 5.4
  //   },
  //   {
  //     name: 'ALBANY',
  //     todaySales: 3317,
  //     todaySalesChange: -16.4,
  //     todayLabour: 23.8,
  //     todayLabourChange: 4.79,
  //     weekSales: 3317,
  //     weekSalesChange: -16.4,
  //     weekLabour: 23.8,
  //     weekLabourChange: 4.8
  //   },
  //   {
  //     name: 'ANGLESEA',
  //     todaySales: 2902,
  //     todaySalesChange: -26.8,
  //     todayLabour: 29.2,
  //     todayLabourChange: 12.77,
  //     weekSales: 2902,
  //     weekSalesChange: -26.8,
  //     weekLabour: 29.2,
  //     weekLabourChange: 12.8
  //   },
  //   {
  //     name: 'ASHBURTON BENTO',
  //     todaySales: 2455,
  //     todaySalesChange: -21.2,
  //     todayLabour: 16.7,
  //     todayLabourChange: 6.06,
  //     weekSales: 2455,
  //     weekSalesChange: -21.2,
  //     weekLabour: 16.7,
  //     weekLabourChange: 6.1
  //   },
  //   {
  //     name: 'ASHBURTON SUSHI',
  //     todaySales: 9082,
  //     todaySalesChange: 11.4,
  //     todayLabour: 15.1,
  //     todayLabourChange: 5.81,
  //     weekSales: 9082,
  //     weekSalesChange: 11.4,
  //     weekLabour: 15.1,
  //     weekLabourChange: 5.8
  //   }
  // ];
  sortDirection: { [key in keyof Store]?: boolean } = {};
  selectedStore: any;

  constructor(private dashboardService: DashboardService) {}

  sortBy(column: keyof Store) {
    this.sortDirection[column] = !this.sortDirection[column];
    const direction = this.sortDirection[column] ? 1 : -1;
    this.stores = [...this.stores].sort((a, b) => {
      if (a[column] < b[column]) return -1 * direction;
      if (a[column] > b[column]) return 1 * direction;
      return 0;
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['dashboardData']) {
      const salesAllShops = this.dashboardData?.sales_all_shops;
      if (Array.isArray(salesAllShops)) {
        this.stores = salesAllShops
          .map((item: any) => ({
            name: item.name,
            shopId: Number(item.shop_id),
            shopType: item.shop_type,
            todaySales: item.sales_today !== null && item.sales_today !== undefined ? parseFloat(item.sales_today) : null,
            todaySalesChange: item.sales_percentage !== null && item.sales_percentage !== undefined ? parseFloat(item.sales_percentage) : null,
            todayLabour: item.today_labour_per !== null && item.today_labour_per !== undefined ? parseFloat(item.today_labour_per) : null,
            todayLabourChange: item.today_labour_per_ly !== null && item.today_labour_per_ly !== undefined ? parseFloat(item.today_labour_per_ly) : null,
            weekSales: item.this_week_sales !== null && item.this_week_sales !== undefined ? parseFloat(item.this_week_sales) : null,
            weekSalesChange: item.sales_percentage_weekly !== null && item.sales_percentage_weekly !== undefined ? parseFloat(item.sales_percentage_weekly) : null,
            weekLabour: item.this_week_labour_per !== null && item.this_week_labour_per !== undefined ? parseFloat(item.this_week_labour_per) : null,
            weekLabourChange: item.this_week_labour_per_ly !== null && item.this_week_labour_per_ly !== undefined ? parseFloat(item.this_week_labour_per_ly) : null,
          }))
          .filter((store: any) => store.todaySales !== 0);
      }
    }
  }
  getArrowHtml(value: any, showStar = false) {
    let arrow = '';
    let colorClass = '';
    if (value > 0) {
      arrow = '▲';
      colorClass = 'cgreen'; // CSS class for green
    } else if (value < 0) {
      arrow = '▼';
      colorClass = 'cred'; // CSS class for red
    } else {
      arrow = '';
      colorClass = '';
    }
    let star = showStar ? "<span class='cstar'>★</span>" : '';
    return `<span class='${colorClass}'>${arrow}</span>${star}`;
  }
  get totalRow() {
    // console.log(this.dashboardData?.sales_all_shops_sum)
    const lastYearYtdLabourPerAllshop = this.dashboardData?.sales_all_shops_sum.last_year_ytd_labour_per;
    let sumTodayLabourPerLyDiff = this.dashboardData?.sales_all_shops_sum.today_labour_per - lastYearYtdLabourPerAllshop;
    sumTodayLabourPerLyDiff = this.setDecimalPoints(sumTodayLabourPerLyDiff, 1);

    const lastYearWeeklyLabourPerLyWeekly = this.dashboardData?.sales_all_shops_sum.last_year_this_week_labor_per;
    let salesAllShopsSumWeeklyLabourPerLy = this.dashboardData?.sales_all_shops_sum.weekly_labour_per - lastYearWeeklyLabourPerLyWeekly;
    salesAllShopsSumWeeklyLabourPerLy = this.setDecimalPoints(salesAllShopsSumWeeklyLabourPerLy, 1);

    return {
      todaySales: this.dashboardData?.sales_all_shops_sum.sales_today,
      todaySalesChange: this.dashboardData?.sales_all_shops_sum.sales_percentage,
      todayLabour: this.dashboardData?.sales_all_shops_sum.today_labour_per,
      todayLabourChange: sumTodayLabourPerLyDiff,
      weekSales: this.dashboardData?.sales_all_shops_sum.this_week_sales,
      weekSalesChange: this.dashboardData?.sales_all_shops_sum.weekly_sales_percentage,
      weekLabour: this.dashboardData?.sales_all_shops_sum.weekly_labour_per,
      weekLabourChange: salesAllShopsSumWeeklyLabourPerLy,
    };
  }

  setDecimalPoints(value: number, decimals: number): number {
    if (value === null || value === undefined || isNaN(value)) return value;
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
  }

  onShopClick(store: any) {
    this.selectedStore = store;
    this.shopSelected.emit(store);
  }

}
